var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrashcan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    stroke: "white",
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.9108 3.6009V19C2.9108 20.1046 3.80623 21 4.9108 21H14.9953C16.0999 21 16.9953 20.1046 16.9953 19V3.6009M13.8028 5.75336V18.7578M10.2347 5.75336V18.7578M6.47887 5.75336V18.7578M20 3.51121H0M13.8028 3.42152V3C13.8028 1.89543 12.9074 1 11.8028 1H8.19718C7.09261 1 6.19718 1.89543 6.19718 3V3.42152",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashcan);
export default __webpack_public_path__ + "static/media/Trashcan.9257563924c12da1adab337366eb8f5c.svg";
export { ForwardRef as ReactComponent };